import Repository from "./Repository";
import store from "../store";

const resource = "/Category";

export default {
    getCategoriesForSelect() {
        return Repository.get(`${resource}/categories-for-select`)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log(error);
            });
    },
    list(withDeleted = false) {
        return Repository.get(`${resource}?withDeleted=${withDeleted}`)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log(error);
            });
    },
    get(id) {
        return Repository.get(`${resource}/${id}`)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                console.log(error);
            });
    },
    create(item) {
        return Repository.post(`${resource}`, item)
            .then((response) => {
                store.commit("setSnack", {
                    message: "Изменения сохранены",
                    color: "success",
                });
                return response;
            })
            .catch((error) => {
                console.log(error);
            });
    },
    update(item) {
        let url = item.id > 0 ? `${resource}/${item.id}` : `${resource}`;

        return Repository.patch(url, item)
            .then((response) => {
                store.commit("setSnack", {
                    message: "Изменения сохранены",
                    color: "success",
                });
                return response;
            })
            .catch((error) => {
                console.log(error);
            });
    },
};
